module.exports = __webpack_public_path__ + "static/img/rank_246.1661a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_246.png
// module id = 69qL
// module chunks = 0